<template>
  <div>
    <v-layout>
      <v-flex>
        <v-btn color="primary" @click="showAddPlanDialog()" :disabled="unableModify"> <v-icon dark>add</v-icon> {{ $t('pricingPlan') }} </v-btn>
      </v-flex>
      <v-flex xs4 md2>
        <v-text-field
          append-icon="filter_list"
          :label="$t('search')"
          single-line
          hide-details
          v-model="search"
          clearable
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-data-table :headers="headers" :items="warehousePricingPlans || []" hide-actions :search="search">
      <template v-slot:items="{ item }">
        <td class="text-xs-left">{{ item.name }}</td>
        <td class="text-xs-left">
          <p
            style="
              white-space: pre-wrap;
              word-break: break-word;
              white-space: pre-line;
              overflow: hidden;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 6;
              text-overflow: ellipsis;
            "
          >
            {{
              item.upcs
                .map(
                  (upcItem, index) =>
                    `${
                      index !== 0 && index % 3 === 0
                        ? `${upcItem.upc}\n`
                        : index === item.upcs.length - 1
                        ? upcItem.upc
                        : `${upcItem.upc} &nbsp; &nbsp; | &nbsp; &nbsp; `
                    }`
                )
                .join('')
            }}
          </p>
        </td>
        <td class="text-xs-left">{{ toDateYYYYMMDD(item.createTime) }}</td>
        <td
          class="text-xs-left"
          style="white-space: pre-wrap; word-break: break-word; max-width: 300px; white-space: pre-line"
        >
          {{ item.note }}
        </td>
        <td class="text-xs-center">
          <v-layout>
            <v-flex md3>
              <v-btn color="primary" icon flat @click="showAddPlanDialog(item, true)">
                <v-icon>content_copy</v-icon>
              </v-btn>
            </v-flex>
            <v-flex md3>
              <v-btn color="primary" icon flat @click="showAddPlanDialog(item)">
                <v-icon>edit</v-icon>
              </v-btn>
            </v-flex>
            <v-flex md3>
              <v-btn :disabled="unableModify" color="primary" icon flat @click="deletePricingPlan(item)">
                <v-icon color="red">cancel</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </td>
      </template>
    </v-data-table>
    <FormSubmitPopup
      :title="title"
      v-model="isShowPricingPlanPopup"
      @popupClose="close()"
      :rightButtonDisabled="pricingPlan.upcs.some(item => !item.upc || item.editMode) || unableModify"
      :rightMethod="savePricingPlan"
      large
    >
      <template v-slot:input>
        <v-container>
          <v-layout row warp>
            <v-flex md3>
              <v-text-field
                v-if="!pricingPlan.key"
                :label="$t('name')"
                :rules="[fieldIsRequired('name'), value => isPricingPlanNameDup((value || '').trim())]"
                v-model.trim="pricingPlan.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs2> </v-flex>
            <v-flex xs2>
              <v-text-field
                :label="$t('inboundFee')"
                v-model.number="curUpc.inboundFee"
                :rules="[fieldIsRequired('inboundFee'), fieldIsNumber('inboundFee')]"
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field
                :label="$t('outboundFee')"
                v-model.number="curUpc.outboundFee"
                :rules="[fieldIsRequired('outboundFee'), fieldIsNumber('outboundFee')]"
              ></v-text-field>
            </v-flex>
            <v-flex xs2>
              <v-text-field
                :label="$t('storageFee')"
                v-model.number="curUpc.storageFee"
                :rules="[fieldIsRequired('storageFee'), fieldIsNumber('storageFee')]"
              ></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field :label="$t('upc')" @keyup.enter="insertUpc" v-model.trim="curUpc.upc"></v-text-field>
            </v-flex>
            <v-flex xs1>
              <v-btn small icon flat color="primary" @click="insertUpc"><v-icon>add</v-icon> </v-btn>
            </v-flex>
            <v-flex xs3 md3>
              <v-btn :disabled="unableModify" color="primary" title="importFile" :loading="isUploading">
                <v-icon dark left>cloud_upload</v-icon>
                {{ $t('batchUpload') }}
                <input
                  v-on:click="clearSelectionCache"
                  type="file"
                  class="hideInput"
                  @change="uploadFile"
                  accept=".csv,.xls,.xlsx"
                />
              </v-btn>
            </v-flex>
            <v-flex xs2 md2>
              <v-btn
                :disabled="unableModify"
                color="primary"
                @click.stop="exportTableData"
              >
                {{ $t('export') }}
            </v-btn>
            </v-flex>
          </v-layout>
          <v-data-table :headers="pricingPlanHeaders" :items="pricingPlan.upcs" hide-actions item-key="upc">
            <template v-slot:items="props">
                <td class="text-xs-left">
                {{ props.item.upc }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.description || '--' }}
                </td>
              <template v-if="!props.item.editMode">
                <td class="text-xs-left">
                  {{ props.item.inboundFee }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.outboundFee }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.storageFee }}
                </td>
              </template>
              <template v-else>
                <td class="text-xs-left">
                  <v-text-field
                    :label="$t('inboundFee')"
                    :rules="[fieldIsRequired('inboundFee'), fieldIsNumber('inboundFee')]"
                    v-model.number.trim="props.item.inboundFee"
                  ></v-text-field>
                </td>
                <td class="text-xs-left">
                  <v-text-field
                    :label="$t('outboundFee')"
                    :rules="[fieldIsRequired('outboundFee'), fieldIsNumber('inboundFee')]"
                    v-model.number.trim="props.item.outboundFee"
                  ></v-text-field>
                </td>
                <td class="text-xs-left">
                  <v-text-field
                    :label="$t('storageFee')"
                    :rules="[fieldIsRequired('storageFee'), fieldIsNumber('inboundFee')]"
                    v-model.number.trim="props.item.storageFee"
                  ></v-text-field>
                </td>
              </template>
              <td class="text-xs-center">
                <v-layout justify-center align-center>
                  <v-flex ml-1 mt-2 md3 xs3>
                    <v-checkbox v-model="props.item.associatedDiscount"></v-checkbox>
                  </v-flex>
                </v-layout>
              </td>
              <template v-if="props.item.editMode">
                <td class="text-xs-center">
                  <v-btn color="primary" flat small icon @click="$set(props.item, 'editMode', false)"
                  ><v-icon>check</v-icon>
                </v-btn>
                <v-btn color="primary" flat small icon @click="cancelEdit(props.item)"
                  ><v-icon>cancel</v-icon>
                </v-btn>
              </td>
              </template>
              <template v-else>
                <td class="text-xs-center">
                  <v-btn :disabled="unableModify" color="primary" flat small icon @click="editItem(props.item)"
                    ><v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn :disabled="unableModify" color="primary" flat small icon @click="pricingPlan.upcs.splice(props.index, 1)"
                    ><v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </template>
          </v-data-table>
          <v-layout mt-3>
            <v-textarea
              :label="$t('note')"
              outline
              v-model="pricingPlan.note"
              rows="1"
              counter="200"
              class="thinBox"
            ></v-textarea>
          </v-layout>
        </v-container>
      </template>
    </FormSubmitPopup>
  </div>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import { checkRules, timeTools, cloneDeep, readXlsxSheetData, exportListToXlsx } from '@/utils/tools'

export default {
  components: { FormSubmitPopup },
  name: 'PricingPlan',
  mixins: [checkRules, timeTools],
  data () {
    return {
      pricingPlan: {
        name: '',
        upcs: [],
        note: ''
      },
      curUpc: this.initUpc(),
      items: [],
      search: '',
      isShowPricingPlanPopup: false,
      title: '',
      tempItem: {},
      isUploading: false
    }
  },
  methods: {
    async uploadFile (e) {
      this.isUploading = true
      try {
        const files = e.target.files
        let rawData = await readXlsxSheetData(files)
        if (rawData.length) this.processSheetData(rawData)
        else this.isUploading = false
      } catch (error) {
        this.isUploading = false
        this.$store.dispatch('showToast', { info: error })
      }
    },
    async processSheetData (rawData) {
      let errMessages = []
      try {
        rawData.forEach(item => {
          let isErrorData = false
          Object.entries(item).forEach(([key, value]) => {
            const validNumber = (key === 'inboundFee' || key === 'outboundFee' || key === 'storageFee')
            const validUpc = (key === 'upc' && this.isDefinedUpc(value) !== true)
            if (validNumber) {
              value = Number(value)
              if ((typeof value !== 'number' && value < 0) || isNaN(value)) {
                errMessages.push(`${key}:${this.$t('editForecastWarning')}`)
                isErrorData = true
              }
            } else if (validUpc) {
              errMessages.push(`${value}:${this.$t('UpcDoesNotExist')}`)
              isErrorData = true
            }
          })
          if (!isErrorData) {
            if (!this.pricingPlan.upcs.some(upcInfo => upcInfo.upc === item.upc)) {
              this.pricingPlan.upcs.push(item)
            } else {
              this.pricingPlan.upcs.forEach(upcInfo => {
                if (upcInfo.upc === item.upc) {
                  upcInfo = item
                }
              })
            }
          }
        })
        if (errMessages.length) {
          this.$store.dispatch('showToast', {
            info: errMessages.join('\n'),
            level: 'warning'
          })
        }
        this.isUploading = false
      } catch (error) {
        this.isUploading = false
        this.$store.dispatch('showToast', { info: error })
      }
    },
    clearSelectionCache (e) {
      e.target.value = null
    },
    
    exportTableData () {
      const headers = ['upc', 'description', 'inboundFee', 'outboundFee', 'storageFee']
      const filename = `PricingPlan-${this.pricingPlan.name}`
      const data = this.pricingPlan.upcs.reduce((content, item) => {
        const result = headers.map(key => {
          return item[key] || (typeof item[key] === 'number' ? 0 : '')
        })
        return [...content, result]
      }, [])
      
      exportListToXlsx(
        [
          headers,
          ...data
        ], filename
      )
    },
    insertUpc () {
      if (this.pricingPlan?.upcs?.some(item => item.upc === this.curUpc.upc)) return this.$store.dispatch('showToast', {info: this.$t('upcAlreadyExists'), level: 'error'})
      let matchedUpc = this.upcs.find(item => item.upc === this.curUpc.upc)
      if (!matchedUpc) return this.$store.dispatch('showToast', {info: this.$t('UpcDoesNotExist'), level: 'error'})
      !this.pricingPlan.upcs && this.$set(this.pricingPlan, 'upcs', [])
      this.pricingPlan.upcs.push({...this.curUpc, description: matchedUpc.description || ''})
      this.curUpc.upc = ''
    },
    isDefinedUpc (upc) {
      return this.upcs.some(item => item.upc === upc) || this.$t('UpcDoesNotExist')
    },
    close () {
      this.isShowPricingPlanPopup = false
      this.pricingPlan = {
        name: '',
        upcs: [],
        note: ''
      }
      this.curUpc = this.initUpc()
    },
    deletePricingPlan (item) {
      if (!confirm(this.$t('confirmDeletePricingPlan'))) return
      let { key = '' } = item 
      return this.$store.dispatch('deleteUpcPricingPlan', {key})
        .then(() => {
          this.$store.dispatch('showToast', {info: this.$t('success'), level: 'success'})
        })
        .catch((error) => {
          this.$store.dispatch('showToast', {info: error.message, level: 'error'})
        })
    },
    isPricingPlanNameDup (name) {
      return !this.warehousePricingPlans.some(pricingPlan => pricingPlan.name === name) || this.$t('nameCanNotBeDuplicated')
    },
    initUpc () {
      return {
        upc: '',
        description: '',
        inboundFee: 0,
        outboundFee: 0,
        storageFee: 0
      }
    },
    savePricingPlan () {
      if (!this.pricingPlan.key && this.warehousePricingPlans.some(pricingPlan => pricingPlan.name === this.pricingPlan.name)) {
        this.$store.dispatch('showToast', {info: this.$t('nameCanNotBeDuplicated'), level: 'error'})
        throw Error(this.$t('nameCanNotBeDuplicated'))
      }
      if (!this.pricingPlan.upcs?.length) {
        this.$store.dispatch('showToast', {info: this.$t('pricingPlanCannotBeEmpty'), level: 'error'})
        throw Error(this.$t('pricingPlanCannotBeEmpty'))
      }
      return this.$store.dispatch('addOrUpdateUpcPricingPlan', this.pricingPlan)
    },
    showAddPlanDialog (item, isCopy) {
      this.title = isCopy ? this.$t('pricingPlanCopy') : this.$t('pricingPlan')
      item && (this.pricingPlan = cloneDeep(item))
      if (isCopy) {
        delete this.pricingPlan.key
        delete this.pricingPlan.name
      }
      this.isShowPricingPlanPopup = true
    },
    editItem (item) {
      this.tempItem = cloneDeep(item)
      this.$set(item, 'editMode', true)
    },
    cancelEdit (item) {
      this.$set(item, 'inboundFee', this.tempItem.inboundFee)
      this.$set(item, 'outboundFee', this.tempItem.outboundFee)
      this.$set(item, 'storageFee', this.tempItem.storageFee)
      this.$set(item, 'editMode', false)
      this.tempItem = {}
    }
  },
  computed: {
    headers () {
      return [
        { text: this.$t('name'), sortable: false, align: 'left', value: 'name', width: '15%' },
        { text: this.$t('upc'), sortable: false, align: 'left', width: '25%' },
        { text: this.$t('createTime'), align: 'left', sortable: false },
        { text: this.$t('note'), align: 'left', sortable: false, width: '20%' },
        { text: this.$t('actions'), align: 'center', sortable: false, width: '10%' }
      ]
    },
    upcs () {
      return Object.values(this.$store.getters.upcMap || {})
    },
    warehousePricingPlans () {
      return this.$store.getters.warehousePricingPlans || []
    },
    pricingPlanHeaders () {
      return [
        { text: this.$t('upc'), sortable: false, value: 'upc', width: '20%' },
        { text: this.$t('description'), sortable: false, value: 'description', width: '20%' },
        { text: this.$t('inboundFee'), sortable: false, value: 'inboundFee' },
        { text: this.$t('outboundFee'), sortable: false, value: 'outboundFee' },
        { text: this.$t('storageFee'), sortable: false, value: 'storageFee' },
        { text: this.$t('associatedDiscount'), sortable: false, align: 'center', value: 'action', width: '10%' },
        { text: this.$t('actions'), sortable: false, align: 'center', value: 'action', width: '10%' }
      ]
    },
    roles () {
      return this.$store.getters.user.roles || []
    },
    unableModify () {
      return !this.roles.some(item => ['warehouseOwner', 'warehousePricing'].includes(item))
    }
  }
}
</script>

<style>
.hideInput {
  position: absolute;
  top: 0;
  left: -15px;
  width: 100px;
  min-height: 100%;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/PricingPlan.vue